import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';
import { ApiService } from './api.service';

@Injectable()
export class MediasService extends ApiService {
  constructor(protected http: HttpService) {
    super(http);
    this.url = 'api/medias/';
  }

  uploadImage(resource: any): Observable<any> {
    return this.http.post(this.url + 'upload', resource, {});
  }
}
